import { TextAssetType, Tone } from './types.d';

export const COPILOT_TITLE = _TL_('Microsoft Advertising can help you:');

export const REVISE_OPTION_TEXT = _TL_('Revise');
export const TRY_DIFFERENT_TONE_OPTION_TEXT = _TL_('Try a different tone');
export const FIND_SIMILAR_OPTION_TEXTS: Record<TextAssetType, string> = {
  headline: _TL_('Find similar short headlines'),
  description: _TL_('Find similar descriptions'),
  longHeadline: _TL_('Find similar long headlines'),
};
export const TONES: Record<Tone, string> = {
  Friendly: _TL_('Friendly'),
  Persuasive: _TL_('Persuasive'),
  Cute: _TL_('Cute'),
  Inspiring: _TL_('Inspiring'),
};
export const REVISE_DIALOG_TITLE_TEXT_MAP: Record<TextAssetType, string> = {
  headline: _TL_('Revise this short headline'),
  longHeadline: _TL_('Revise this long headline'),
  description: _TL_('Revise this description'),
};
export const TRY_DIFFERNT_TONE_TITLE_TEXT = _TL_('Try a different tone');
export const FIND_SIMILAR_TITLE_TEXT_MAP = {
  headline: _TL_('Find similar short headlines'),
  longHeadline: _TL_('Find similar long headlines'),
  description: _TL_('Find similar descriptions'),
};

export const UPDATED_RECOMMENDATION_TEXT = _TL_('We\'ve updated your recommendations:');
export const REPLACE_BTN_TEXT = _TL_('Replace existing assets');

export const FIND_SIMILAR_LOADING_DESC = _TL_('Microsoft Advertising will generate a variety of new assets.');
export const LOADING_TEXT = _TL_('Generating recommendations');

export const TRY_AGAIN_BTN_TXT = _TL_('Try again');

export const REVISE_DESCRIPTION = _TL_("Microsoft Advertising will use the descriptions that you provide to generate new asset recommendations. If your description doesn’t match your website's content, we’ll generate recommendations entirely from your Final URL.");
export const REVISE_TEXTAREA_HINT: Record<TextAssetType, string> = {
  headline: _TL_('How would you like to change this headline?'),
  description: _TL_('How would you like to change this description?'),
  longHeadline: _TL_('How would you like to change this long headline?'),
};
export const REVISE_TEXTAREA_PLACEHOLDER = _TL_('Choose what you would you like to include or exclude in your ads.');
export const REVISE_DIALOG_TOOLTIP = _TL_("Microsoft Advertising will use the descriptions that you provide to generate new asset recommendations. If your description doesn’t match your website's content, we’ll generate recommendations entirely from your Final URL.");
export const NO_OPTIONS_TEXT = _TL_('No options found.');
